import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {
  runLocationCheckIn, loadRun, saveRun, deleteRun, saveRunReorder,
  runLocationCompletePickup
} from '../../actions/runActions';
import { loadRunReceipts, assignReceipt, unassignReceipt } from '../../actions/receiptActions';
import { subscribeToTruck } from '../../utils/truckHub';
import Run from './Run';
import { IsInRole, ROLE_Admin, ROLE_SuperUser, allowUserWithRoles } from '../../constants';
import { withRouter } from '../../utils/withRouter';


class RunPage extends React.Component {
  constructor(props, context) {
    super(props, context);
     this.saveRun = this.saveRun.bind(this);
     this.savereOrderRun = this.savereOrderRun.bind(this);
  }

  componentDidMount(){
    this.props.dispatch(loadRun(this.props.runId, this.props.driverRuns, this.props.searchRuns, false, false));
    this.props.dispatch(loadRunReceipts(this.props.runId));
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps){
    // Subscribe to the run's truck hub group once the run has loaded, so receipt pushes arrive live.
    const plate = this.props.run && this.props.run.truckNumberPlate;
    const prevPlate = prevProps.run && prevProps.run.truckNumberPlate;
    if (plate && plate !== prevPlate) {
      subscribeToTruck(plate);
    }
  }

 saveRun(run){
    let current = this.props.run;
    this.props.dispatch(saveRun(run, current));
  }

  savereOrderRun(run){
    let current = this.props.run;
    this.props.dispatch(saveRunReorder(run, current));
  }

  render() {
    let {run, account, runReceipts} = this.props;
    // "Available to pick" = not yet tied to a specific tank. A receipt may already carry the run id
    // (the truck knows the current run) and even a pickupId from truck-proxy context, but it isn't
    // "used" until it's bound to a specific tank — which only the picker (assignReceipt) does.
    let allReceipts = (runReceipts && runReceipts.runId === run.id && Array.isArray(runReceipts.items))
      ? runReceipts.items : [];
    let unassignedReceipts = allReceipts.filter(r => !r.tankId);
    return (
      <div ref="runpage">
        {run && (
            <Run run={run}
                 onLocationCheckin={(runId, pickupId, status) => this.props.dispatch(runLocationCheckIn(runId, pickupId, status))}
                 onRunRefresh={()=>this.props.dispatch(loadRun(run.id, null, null, false, false))}
                 loadRun={(id,driveRun, search, a,hideSmsNoResponse) => this.props.dispatch(loadRun(run.id,driveRun, search, a,hideSmsNoResponse))}
                 unfinishedRun={this.props.unfinishedRun}
                 showLink={false}
                 isMapView={false}
                 isListView
                 onSaveRun={this.saveRun}
                 isAdmin={allowUserWithRoles(account, [ROLE_Admin, ROLE_SuperUser])}
                 onLoadDriverLocations={()=>this.props.dispatch(loadRun(run.id, null, null, true, false))}
                 drivers={this.props.drivers}
                 trucks={this.props.trucks}
                 showEdit={allowUserWithRoles(account, [ROLE_Admin, ROLE_SuperUser])}
                 onDeleteRun={(runId) => this.props.dispatch(deleteRun(runId))}
                 onSaveReorderRun={this.savereOrderRun}
                 onCompletePickup={(pickup, isCancel) => this.props.dispatch(runLocationCompletePickup(pickup, isCancel))}
                 unassignedReceipts={unassignedReceipts}
                 allReceipts={allReceipts}
                 receiptsLoading={runReceipts && runReceipts.loading}
                 onAssignReceipt={(receiptId, pickupId, tankId) => this.props.dispatch(assignReceipt(run.id, receiptId, pickupId, tankId))}
                 onUnassignReceipt={(receiptId) => this.props.dispatch(unassignReceipt(run.id, receiptId))}
                 onRefreshReceipts={() => this.props.dispatch(loadRunReceipts(run.id))}
                 scrollToLocationId={this.props.locationId}
                 tankId={this.props.tankId}
            />
        )}
      </div>
    );
  }
}

RunPage.propTypes = {
  runId: PropTypes.number.isRequired,
  run: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  searchRuns: PropTypes.object.isRequired,
  driverRuns: PropTypes.object.isRequired,
  drivers: PropTypes.object.isRequired,
  trucks: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps){

  let runId = parseInt(ownProps.routeParams.id);
  let locationId = parseInt(ownProps.routeParams.locationId);
  let tankId = parseInt(ownProps.routeParams.tankId);
  let run = null;
  let unfinishedRun = null;

  //look at state.driverRuns and state.searchRuns, attempt to get the run from there

  if(runId && state.driverRuns && state.driverRuns.items.length > 0){
    let filtered = state.driverRuns.items.filter(x => x.id == runId);

    if(filtered.length == 1){
      run = filtered[0];

      //are any runs checked in, and if so is it this one
      let unfinished = state.driverRuns.items.filter(x => !x.isComplete && x.id!=runId && x.isCurrentUserDriver);
      unfinishedRun = unfinished.length > 0 ? unfinished[0] : null;

      if(unfinishedRun && run && run.isBaseCheckedIn){
        unfinishedRun = null;
      }
    }
  }
  if(state.run && state.run.id == runId){
    run = state.run;
  }
  if(!run){
    run = {};
  }

  return {
    run: run,
    unfinishedRun: unfinishedRun,
    runId: runId,
    searchRuns: state.searchRuns,
    driverRuns: state.driverRuns,
    account: state.account,
    drivers: state.drivers,
    trucks: state.trucks,
    runReceipts: state.runReceipts,
    locationId,
    tankId,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RunPage));
